import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  IPostPartnerBusinessDocumentsParams,
  TPostPartnerBusinessDocumentsResponse,
} from "./postPartnerBusinessDocuments.schema";

export const postPartnerBusinessDocuments = (axios: IAxiosInstance) => {
  return async (
    params: IPostPartnerBusinessDocumentsParams
  ): Promise<TPostPartnerBusinessDocumentsResponse> => {
    const { whiteLabelID, ein_letter, additional_documents } = params;
    const formData = new FormData();
    if (ein_letter) {
      formData.append("ein_letter", ein_letter);
    }
    additional_documents.forEach((document) => {
      formData.append("additional_documents", document);
    });

    const response = await axios.noRetry.post<
      IApiResponse<TPostPartnerBusinessDocumentsResponse>
    >(`/api/partners/${whiteLabelID}/business-documents`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    const resData = response.data;
    if (resData?.data?.success) {
      return {
        success: true,
        message: resData.data?.message,
      };
    }
    throw new Error("Something went wrong");
  };
};
